import { defineStore } from 'pinia'

export const useMarketStore = defineStore('market', {
  state: () => (
    {
      products: undefined,
      productsPromise: undefined,
      subscriptions: undefined,
    }),
  getters: {
  },
  actions: {
    setProducts(products) {
      this.products = products;
    },
    setProductsPromise(productsPromise) {
      this.productsPromise = productsPromise;
    },
    setSubscriptions(subscriptions) {
      this.subscriptions = subscriptions;
    },
  },
});
